import * as React from "react";
export default function  AbaSaques(props) {
  return (
    <svg
      width={42}
      height={41}
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#a)">
        <g clipPath="url(#b)">
          <rect x={1} width={40} height={40} rx={12} fill="url(#c)" />
          <g clipPath="url(#d)" filter="url(#e)">
            <path
              d="M33 26H12l2.6 2.6-1.417 1.411-3.6-3.6a2 2 0 0 1 0-2.828l3.57-3.569 1.413 1.414L12 24h21zm-5.574-7.427 1.414 1.414 3.574-3.573a2 2 0 0 0 0-2.828l-3.593-3.593-1.414 1.414L30 14H9v2h21z"
              fill="url(#f)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="c"
          x1={21}
          y1={0}
          x2={21}
          y2={40}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29282C" />
          <stop offset={1} stopColor="#100F11" />
        </linearGradient>
        <linearGradient
          id="f"
          x1={8.812}
          y1={5.88}
          x2={22.229}
          y2={29.46}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" />
          <stop offset={1} stopColor="#fff" stopOpacity={0.65} />
        </linearGradient>
        <clipPath id="b">
          <rect x={1} width={40} height={40} rx={12} fill="#fff" />
        </clipPath>
        <clipPath id="d">
          <path fill="#fff" d="M9 8h24v24H9z" />
        </clipPath>
        <filter
          id="a"
          x={0.5}
          y={0}
          width={41}
          height={41}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={0.25} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2813_11446"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_2813_11446"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={0.25} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0" />
          <feBlend in2="shape" result="effect2_innerShadow_2813_11446" />
        </filter>
        <filter
          id="e"
          x={-21}
          y={-18.102}
          width={84}
          height={84}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={10} />
          <feGaussianBlur stdDeviation={10} />
          <feColorMatrix values="0 0 0 0 0.118924 0 0 0 0 0.158031 0 0 0 0 0.570833 0 0 0 0.4 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2813_11446"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.899} />
          <feGaussianBlur stdDeviation={15} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0" />
          <feBlend
            in2="effect1_dropShadow_2813_11446"
            result="effect2_dropShadow_2813_11446"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_2813_11446"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
  
}